import { useScript } from '../../../hooks/useScript';

export const useGoogleMaps = (): boolean => {
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY || '';
  const [loaded, error] = useScript(`https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}`);

  return loaded && !error;
};
